<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import VueBarcode from "vue-barcode";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import Vue from "vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
import MaskedInput from 'vue-text-mask'
Vue.component('v-select', vSelect)
// register the plugin on vue
import Toasted from 'vue-toasted';
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";

Vue.use(Toasted);
/**
 * Productos
 */
export default {
  page: {
    title: "Agregar",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout, PageHeader, barcode: VueBarcode,'masked-input': MaskedInput,"fulfilling-bouncing-circle-spinner":FulfillingBouncingCircleSpinner },
  data() {
    return {
      submitted : false,
      localImagen: null,
      apiUrl: process.env.VUE_APP_URL,
        formMarca: {
        nombre: "",
        descripcion: "",
        state: true,
        id: 0,
      },
      userT : this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token}
      },
      cabezera2: [
        { key: "descripcion", label: "Descripción", thClass: "cell1" },
        { key: "Precio", label: "Precio", thClass: "cell2" },
        { key: "porcentaje", label: "Porcentaje", thClass: "cell3" },
        { key: "Ganancia", label: "Ganancia", thClass: "cell4" },
      ],
      repitprove : true,
     
      apiBase: process.env.VUE_APP_URL +"productos/stock/busqueda?departamento="+ 0 + '&estante='+ 0,
      showModalProve:false,
      showModalMar:false,
      showModalPre:false,
      showModalL:false,
      repitCategoria : true,
      arrayEstante:[],
      estanteModel : "",
      idstockT:0,
      arrayDetalle:[],
      cantidad:"",
      seccion:"",
      estado_cantidad:false,
      estado_seccion:false,
      estado_tipo:true,
      dismissCountDown: 0,
      dismissSecs: 4,
      title: "Agregar Producto",
      items: [
        {
          text: "Productos",
          href: "/",
        },
        {
          text: "Stock",
          active: true,
        },
      ],
       mask_quetzal: createNumberMask({
          prefix: "Q ",
          suffix: "",
          includeThousandsSeparator: true,
          thousandsSeparatorSymbol: ",",
          allowDecimal: true,
          decimalSymbol: ".",
          decimalLimit: 2, // how many digits allowed after the decimal
          integerLimit: 10, // limit length of integer numbers
          allowNegative: false,
          allowLeadingZeroes: false,
      }),
        options : {
          theme: "outline",  
          position: "top-right", 
          duration : 5000,
          keepOnHover:true,
          action : {
            text : 'X',
            onClick : (e, toastObject) => {
                toastObject.goAway(0);
          },
         
    },
      },
      repit_codigo: true,
      repit_nombre: true,
      repitMar: true,
      arrayCategorias:[],
      arrayDepa:[],
      arrayMarcas:[],
      arrayAuto:[],
      arrayModelo:[],
      autoid:0,
      ubicacionModel : 0,
       formPro: {
        code: "",
        stock_min:"",
        stock_max:"",
        modelo:"",
        autoid:"",
        existencia : "",
       /*  marca: "", */
       no_parte :"",
       categoria:"",
        marca:null,
        departamento:"",
        precio_compra:"",
        precio_venta:"",
        nombre:"",
        descripcion:"", 

        state: true,
        id: 0,
      },
      formCategoria: {
        nombre: "",
        /* subpresentacion: "",
        subpresentaciones: [], */
        id: 0,
        state: true,
      },
      total:0,
      tiendaid:0,
      tienda:"",
      mask_porcentaje: createNumberMask({
        prefix: "",
        suffix: " %",
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ",",
        allowDecimal: true,
        decimalSymbol: ".",
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false,
      }),
      stateValue: null,
      countryValue: null,
      arrayData:[]
    };
  },
  validations: {
     formMarca: {
      nombre: {
        required,
        async isUnique (value) {
            if (value === '') return true
            // simulate async call, fail for all logins with even length
            let response = await axios.get( process.env.VUE_APP_URL +'marcas/nombre_repetido?nombre='+ value  + '&id='+this.formMarca.id,{
              headers: { "x-token": this.userT.token}
            }).catch(console.log);
            this.repitMar = response.data.msg;
            return response.data.msg
        } 
      },
      descripcion: { required },
    }, 
  
    formPro: {
      code: {  required,
        async isUnique (value) {
            if (value === '') return true
            let response = await axios.get( process.env.VUE_APP_URL +'productos/codigo_repetido?codigo='+ value + '&id='+this.formPro.id ,{
            headers: { "x-token": this.userT.token}
          } ).catch(console.log);
            this.repit_codigo = response.data.msg;
            return response.data.msg
          } 
      },
      stock_min: { required },
      existencia : {required},
    /*   marca: { required }, */
      marca: { required },
      nombre: { required, async isUnique (value) {
            if (value === '') return true
            const id = this.formPro.marca ==null ? 0 : this.formPro.marca.id;
            const idproducto = this.formPro.id ==null ? 0 : this.formPro.id;


            let response = await axios.get( process.env.VUE_APP_URL +'productos/nombre_repetido?nombre='+ value + '&marca='+id + '&id=' + idproducto ,{
            headers: { "x-token": this.userT.token}
          } ).catch(console.log);
            this.repit_nombre = response.data.msg;
            return response.data.msg
          }  },
      descripcion: { required }, 
      categoria: { required },
      precio_compra: { required },
      precio_venta: { required },
    },
     formCategoria: {
      nombre: {
        required,
          async isUnique (value) {
            if (value === '') return true
            let response = await axios.get(process.env.VUE_APP_URL +'categorias/nombre_repetido?nombre='+ value  + '&id='+this.formCategoria.id,{
            headers: { "x-token": this.userT.token}
          }).catch(console.log);
            this.repitCategoria = response.data.msg;
            return response.data.msg
          }
      },
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    onSelectedImagen(event) {
      const file = event.target.files[0];
      if (!file) {
        this.localImagen = null;
        return;
      }
      this.file = file;
      const fr = new FileReader();
      fr.onload = () => (this.localImagen = fr.result);
      fr.readAsDataURL(file);
    },
    onSelectImagen() {
      this.$refs.imageSelector.click();
    },
    limpiarModalmar(){
      this.formMarca.nombre = '';
      this.formMarca.id = 0;
    /*   this.formMarca.descripcion = ''; */
    },
  //modal y validaciones

     validacionesMar(opc) {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      //  console.log(this.repit)
      if (this.formMarca.nombre=="" || this.repitMar == false) {
        return;
      } else {
        this.showModalL= true;
        if (opc=="saveMar") {
        /*  this.savemar(); */
        }
       
      }
      
      
    },
     savemar(){
       const { nombre, descripcion  } =this.formMarca;
      axios
        .post(process.env.VUE_APP_URL + "marcas/store", {
          nombre: nombre,
          descripcion: descripcion
        },{
            headers: { "x-token": this.userT.token}
          })
        .then((response) => {
        Vue.toasted.success((nombre+" Guardado"),this.options);
          // console.log(response)
           this.arrayMarcas.push(response.data)
           this.formPro.marca = response.data;
          this.showModalMar = false;
          this.limpiarModalmar();
          this.submitted = false;
          
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
           Vue.toasted.error("Error para guardar",this.options);
        }).finally(() =>{
        
       this.showModalL= false;
        });
    }, 
  
  
    saveCategoria(){
      const { nombre } =this.formCategoria;
      const me = this;
      axios
        .post(process.env.VUE_APP_URL + "categorias/store", {
          nombre: nombre,
        },{
            headers: { "x-token": this.userT.token}
          })
        .then((response) => {
          Vue.toasted.success((nombre+" Guardado"),me.options);
           me.arrayCategorias.push(response.data)
          this.formPro.categoria = response.data;
          // console.log(this.formPro.categoria)
           me.showModalPre=false;
        })
        .catch((error) => {
          me.errorMessage = error.message;
          console.error("Error!", error);
           Vue.toasted.error("Error para guardar",me.options);
        }).finally(() =>{
          me.showModalL= false;
        });
    },
    validacionesMarca(opc){
      this.$v.$touch();
      if (this.formMarca.nombre==="" || this.repitMar == false) {
        return;
      } else {
        this.showModalL= true;
        if (opc=="save") {
         this.savemar();
        }
      }
    },
    validacionesPre(opc){
      this.$v.$touch();
      if (this.formCategoria.nombre==="" || this.repitCategoria == false) {
        return;
      } else {
        this.showModalL= true;
        if (opc=="save") {
         this.saveCategoria();
        }
      }
    },

    openModal(model) {
      switch (model) {
        case "saveCategoria": {
        this.$v.$reset();
        this.limpiarVariablespre();
          break;
        }
        case "saveprove": {
        this.$v.$reset();
        this.limpiarVariablesprove();
          break;
        }
        case "update": {
        this.$v.$reset();
          break;
        }
      }
    },
  limpiarVariablespre(){
   this.formCategoria.id=0;
   this.formCategoria.nombre="";
},
    //Variables que necesitan ser limpiadas para los modales
limpiarVariablesprove(){
   this.formPro.id=0;
   this.formPro.telefono = "";
   this.formPro.nombre="";
   this.formPro.nit="C/F";
   this.formPro.direccion = "";
},
   // eslint-disable-next-line no-unused-vars
   onActionClicked(action){
  if(action=="new-pre"){
          this.formCategoria.id=0;
          this.formCategoria.nombre = "";
      }
  if(action=="modalSaveMar"){
          this.formMarca.id=0;
          this.formMarca.nombre = "";
      }
    
   }, //generar code
    crear(opc){
      if(opc=='code'){
        this.formPro.code = "";
                var characters =
                  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
                var charactersLength = characters.length;
                for (var i = 0; i < 10; i++) {
                  this.formPro.code += characters.charAt(
                    Math.floor(Math.random() * charactersLength)
        );
      }
    }
    },
    //regresar de porcentaje a numero normal
    convertMaskToPorcentaje(value){
       var re = /(\d*\.?\d*)\s*%/
       var pctvalue = value.match(re)
       if(value==""){
        return (0);
       }
      if (pctvalue) {
        return  parseFloat(pctvalue[1]);
      }
      else{
      return parseFloat(value)
      }
    },
    //regresar a numero
    convertMaskToNumber(value) {
      var myNumber = "";
      for (var i = 0; i < value.length; i += 1) {
        if (
          value.charAt(i) === "Q" ||
          value.charAt(i) === "," ||
          value.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += value.charAt(i);
        }
      } 
      return parseFloat(myNumber).toFixed(2);
    },
  //Validaciones antes de guardar
  validaciones(opc) {
  // stop here if form is invalid
  const { code, nombre, stock_min, precio_compra, precio_venta, categoria, marca, existencia } = this.formPro;
    this.$v.$touch();
    
    if (( code=="" || this.repit == false || nombre=="" || stock_min=="" || existencia=="" ||categoria == null || marca == null|| 
      precio_compra== "" || precio_venta== "" ||  this.repit_codigo != true || this.repit_nombre != true)) {
      this.dismissCountDown = this.dismissSecs;
      return;

    }
    else if (opc=="update") {
        this.showModalL= true;
         this.update()
    }
      
     else if(this.$route.params.opc=='save') {
      // console.log('esta llegando al save')
        this.save();
    }


  },
  //contador para notificaciones validando todo
   countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },

  guardarinfo(nombreim){
    const me = this;
    const {
        code,
        stock_min,
        stock_max,
        modelo,
        marca,
        nombre,
        presentacion,
        precio_compra,
        precio_venta,
        precio_taller,
        precio_mayore,
        porcentaje_venta,
        porcentaje_taller,
        porcentaje_mayore,
       /*  descripcion, */
        } =this.formPro;
        const data=this.addmodelo(modelo);
    axios
          .post(process.env.VUE_APP_URL + "productos/stock/storeinfo",{
          'producto':parseInt(this.$route.params.id),
          'codigo':code,
          'nombre':nombre,
          'notificacion_min':parseInt(stock_min),
          'notificacion_max':parseInt(stock_max),
          'datos':JSON.stringify(data),
          'subpresentacion':presentacion.id,
          'precio_compra':parseFloat(me.convertMaskToNumber(precio_compra)),
          'precio_venta':parseFloat(me.convertMaskToNumber(precio_venta)),
          'precio_taller':parseFloat(me.convertMaskToNumber(precio_taller)),
          'precio_mayoreo':parseFloat(me.convertMaskToNumber(precio_mayore)),
          'porcentaje_venta':this.convertMaskToPorcentaje(porcentaje_venta),
          'porcentaje_tayer':this.convertMaskToPorcentaje(porcentaje_taller),
          'porcentaje_mayoreo':this.convertMaskToPorcentaje(porcentaje_mayore),
          'marca':marca.id,
          'nombreimagen':nombreim? nombreim:'NO',
          'estado_tipo':this.estado_tipo,
          'detalles': JSON.stringify(this.arrayDetalle),
          'existencia':this.total},{
            headers: { "x-token": this.userT.token, 
                  'Access-Control-Allow-Origin':'*'}
          })
          .then((response) => {
            me.idstockT=response.data.producto;
            // console.log(response.data);
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("Error!", error);
            Vue.toasted.error("Error para guardar",this.options);
            this.showmodalL = false;
          }).finally(() =>{
            Vue.toasted.success(("Registro Guardado"),this.options);
              this.showModalL= false;
                this.$router.push({
                name: "productos",
                shallow: true,
            }); return; }, 1000);
  },
  save(){
    const { code, nombre, stock_min, precio_compra, precio_venta, categoria, marca,  existencia, descripcion } = this.formPro;
    
    let data = new FormData();
          data.append('codigo', code)
          data.append('categoria', categoria.id)
          data.append('nombre', nombre);
          data.append('descripcion', descripcion)
          data.append('marca', marca.id)
          data.append('notificacion', stock_min)
          data.append('existencia', existencia)
          data.append('archivo', this.file)
          data.append('precio_compra',  parseFloat(this.convertMaskToNumber(precio_compra)))
          data.append('precio_venta',  parseFloat(this.convertMaskToNumber(precio_venta)))
     axios
      .post(process.env.VUE_APP_URL + "productos/store",data,{
            headers: { "x-token": this.userT.token,  'Content-Type': 'multipart/form-data', 
                  'Access-Control-Allow-Origin':'*'}
          })
      .then(() => { 
        Vue.toasted.success(("Registro Guardado"),this.options);
              this.showModalL= false;
                this.$router.push({
                name: "productos",
                shallow: true,
            }); 
      }).catch((error) => {
        this.errorMessage = error.message;
        console.error("Error!", error);
        Vue.toasted.error("Error para guardar",this.options);
        this.showmodalL = false;
      })
   
  },

  update(){
    const { code, nombre, stock_min, precio_compra, precio_venta, categoria, marca, existencia,  descripcion } = this.formPro;

    let data = new FormData();
        data.append('codigo', code)
          data.append('categoria', categoria.id)
          data.append('nombre', nombre);
          data.append('descripcion', descripcion)
          data.append('marca', marca.id)
          data.append('notificacion', stock_min)
          data.append('existencia', existencia)
          data.append('archivo', this.file)
          data.append('precio_compra',  parseFloat(this.convertMaskToNumber(precio_compra)))
          data.append('precio_venta',  parseFloat(this.convertMaskToNumber(precio_venta)))
          data.append('id',parseInt(this.$route.params.id));
          // console.log(this.$route.params.id)
    axios
      .put(process.env.VUE_APP_URL + "productos/update", data,{
            headers: { "x-token": this.userT.token,   'Content-Type': 'multipart/form-data', 
                  'Access-Control-Allow-Origin':'*'}
          })
      .then(() => {
       
          this.showModalN=false;
      })
      .catch((error) => {
        this.errorMessage = error.message;
        console.error("Error!", error);
          Vue.toasted.error("Error para guardar",this.options);
      }).finally(() =>{
       setTimeout(() =>  ( Vue.toasted.success(("Registro Actualizado"),this.options),this.showModalL= false,this.$router.push({
            name: "productos",
            shallow: true,
        })), 2000);
         
      });
  },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
 
    async getMarcas(){
      this.arrayMarcas = [];
            try{
                const response = await axios.get(process.env.VUE_APP_URL + "marcas/busqueda",{
            headers: { "x-token": this.userT.token}
          });
                this.arrayMarcas = response.data.data;
                // console.log(this.arrayMarcas)
            }catch(error){
                console.log(error)
            }
    },
 //BÚSQUEDAS
    async selectCategoria() {
        let me = this;
        this.arrayCategorias = [];
        try{
            const response = await axios.get(process.env.VUE_APP_URL + "categorias/busqueda",{
            headers: { "x-token": this.userT.token}
          });
            me.arrayCategorias = response.data.data;
            // console.log(me.arrayCategorias)
        }catch(error){
            console.log(error)
        }
 
    },
    //Detalle actualizar
    detallProducto(){
      if(this.$route.params.opc=='update'){
        console.log(this.$route.params.id);
  axios
      .get(process.env.VUE_APP_URL + "productos/viewProducto?id=" + this.$route.params.id,{
            headers: { "x-token": this.userT.token}
          })
      .then((response) => {
      // console.log()
          const producto = response.data.data;
        console.log(producto);
        this.formPro.id = producto.id;
        this.formPro.code=producto.codigo_stock;
        this.formPro.stock_min=producto.notificacion
        this.formPro.marca=producto.marca 
        this.formPro.existencia=producto.existencia 
        this.formPro.categoria=producto.categoria 
        this.formPro.nombre=producto.nombre_producto;
        this.formPro.descripcion=producto.descripcion_producto; 
        this.formPro.precio_compra=this.money(producto.precio_compra)
        this.formPro.precio_venta=this.money(producto.precio_venta)
        // this.formPro.autoid=producto.detalle_modelos[0].modelo.auto;
        // this.formPro.modelo=this.formatearModelos(producto.detalle_modelos);
        // this.autodetalle(this.autoid);
    

      }).finally(()=>{
      });
        
      }
   
   },
 
 
  },
  async mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  this.getMarcas();
  this.detallProducto();
 /*  this.getmarcas() */
  this.selectCategoria(1);
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),

  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="this.$route.params.opc=='update' ? 'Actualizar Producto' : title" :items="items" />
    <b-modal
              centered
              v-model="showModalL"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
              no-close-on-backdrop
             content-class="my-class"
             header-class="my-class"
                  >
                    <form>
                      <div class="row">
                        <div class="col-12">
                          <div class="d-flex justify-content-center">
                            
                         <fulfilling-bouncing-circle-spinner
                          :animation-duration="2000"
                          :size="90"
                          color="#2a3042"
                          />
                          </div>
                        </div>
                      
                       
                      </div>

                      
                    </form>
    </b-modal>

    <!-- Modal de Nuevo Registro Marca-->  
            <b-modal
              centered
              v-model="showModalMar"
               id="modalSaveMar"
              ref="modalSaveMar"
              title="Nueva Marca"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form @submit.prevent="validacionesMar('saveMar')">
                      <div class="row">
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="name">Nombre</label>
                            <input
                              id="name"
                              v-model="$v.formMarca.nombre.$model"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese un nombre"
                              :class="{
                                'is-invalid': $v.formMarca.nombre.$error,
                              }"
                              @input="$v.formMarca.nombre.$touch()"
                            />
                            <div
                              v-if="  $v.formMarca.nombre.$error &&!$v.formMarca.nombre.required
                              "
                              class="invalid-feedback"
                            >
                              El nombre es obligatorio.
                            </div>
                            <div
                              v-if="!$v.formMarca.nombre.isUnique"
                              :class="{
                                'invalid-feedback': !$v.formMarca.nombre.isUnique,
                              }"
                            >
                                El nombre de la marca {{formMarca.nombre}} ya existen en nuestros registros.
                            </div>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="mb-3">
                            <label for="phone">Descripción</label>
                            <input
                              id="phone"
                              v-model="formMarca.descripcion"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese una Descripción"
                              :class="{
                                'is-invalid':
                                  submitted && $v.formMarca.descripcion.$error,
                              }"
                            />
                            <div
                              v-if="submitted && !$v.formMarca.descripcion.required"
                              class="invalid-feedback"
                            >
                              La descripción es requerida.
                            </div>
                          </div>
                        </div>
                        
                       
                      </div>

                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalMar = false">Cerrar</b-button>
                        <b-button type="submit" variant="success" class="ms-1" @click="validacionesMarca('save')"
                          >Guardar</b-button
                        >
                      </div>
                    </form>
            </b-modal>
<!-- Modal de Nuevo Registro marca-->  
        
    <!-- Modal de Nuevo Registro Categoria-->  
            <b-modal
              centered
              @show="openModal('saveCategoria')"
              @hidden="openModal('saveCategoria')"
              v-model="showModalPre"
              id="modalSaveCategoria"
              ref="modalSaveCategoria"
              title="Nueva categoría"
              title-class="text-black font-18"
              body-class="p-3"
              hide-footer
                  >
                    <form >
                      <div class="row">
                        <div class="col-12">
                           <div class="mb-3">
                              <label for="name">Nombre</label>
                              <input
                                id="name"
                                v-model="$v.formCategoria.nombre.$model"
                                type="text"
                                class="form-control"
                                placeholder="Ingrese un nombre"
                                :class="{
                                  'is-invalid': $v.formCategoria.nombre.$error,
                                }"
                                @input="$v.formCategoria.nombre.$touch()"
                              />
                              <div
                                v-if="  $v.formCategoria.nombre.$error &&!$v.formCategoria.nombre.required
                                "
                                class="invalid-feedback"
                              >
                                El nombre es obligatorio.
                              </div>
                              <div
                                v-if="!$v.formCategoria.nombre.isUnique"
                                :class="{
                                  'invalid-feedback': !$v.formCategoria.nombre.isUnique,
                                }"
                              >
                                  El nombre de la categoría {{formCategoria.nombre}} ya existen en nuestros registros.
                              </div>
                            </div>
                        </div>
                      </div>
                      <div class="text-end pt-5 mt-3">
                        <b-button variant="light" @click="showModalPre = false">Cerrar</b-button>
                        <b-button @click="validacionesPre('save')" variant="success" class="ms-1"
                          >Guardar</b-button
                        >
                      </div>
                    </form>
            </b-modal>
          <div class="checkout-tabs">
       
                              <b-alert  v-if="this.$route.params.opc=='save'"
                                :show="dismissCountDown"
                                dismissible
                                variant="danger"
                                @dismissed="dismissCountDown = 0"
                                @dismiss-count-down="countDownChanged"
                                >
                                
                              <i class="mdi mdi-block-helper me-2"></i>Error - Revise todos los campos {{ dismissCountDown }} seg.
                            </b-alert>
   
          <b-card-text>
            <div class="text-end">
              <div class="row ">
                <div class="col-sm-12 justify-content-end">
                  <div>
                      <router-link
                       :to="{
                          name: 'productos',
                        }"
                      >
                      <b-button
                        variant="outline-primary"
                        type="button"
                        class="btn btn-rounded mb-2 me-2"
                      >
                      <i class="mdi mdi-arrow-collapse-left"></i> Regresar
                      </b-button>
                      </router-link>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Datos</h4>
                <p class="card-title-desc">Información del producto</p>
                <form>
                   <b-row class="mb-4" >
                    <b-col md="2">
                      <label for="example-textarea">Nombre</label>
                    </b-col>
                    <b-col md="10">
                     <b-form-input 
                              id="nombre"
                              v-model="$v.formPro.nombre.$model"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese un nombre"
                              :class="{
                                'is-invalid': $v.formPro.nombre.$error,
                              }"
                              @input="$v.formPro.nombre.$touch()"
                            ></b-form-input>
                        <div
                          :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.nombre.$error && !$v.formPro.nombre.required,
                          }"
                        >
                        Debe seleccionar un nombre
                  </div>
                  <div
                              v-if="!$v.formPro.nombre.isUnique"
                              :class="{
                                'invalid-feedback': !$v.formPro.nombre.isUnique,
                              }"
                            >
                                El Nombre {{formPro.nombre}} ya existen en nuestros registros.
                            </div>
                    </b-col>
                  </b-row>
                   <b-row class="mb-4" >
                    <b-col md="2">
                      <label for="example-textarea">Descripción</label>
                    </b-col>
                    <b-col md="10">
                     <b-form-input 
                              id="nombre"
                              v-model="$v.formPro.descripcion.$model"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese descripción"
                      ></b-form-input>
                      <div
                          :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.descripcion.$error && !$v.formPro.descripcion.required,
                          }"
                        >
                        Debe seleccionar un descripción	
                  </div>
                    
                    </b-col>
                  </b-row>
                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="input-name">Código</label>
                    </b-col>
                    <b-col md="8">
                      <b-form-group> 
                     <input
                              id="name"
                              v-model="$v.formPro.code.$model"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese un Codigo"
                              :class="{
                                'is-invalid': $v.formPro.code.$error,
                              }"
                              @input="$v.formPro.code.$touch()"
                            />
                            <div
                              v-if="  $v.formPro.code.$error &&!$v.formPro.code.required
                              "
                              class="invalid-feedback"
                            >
                              El Codigo es obligatorio.
                            </div>
                             <div
                              v-if="!$v.formPro.code.isUnique"
                              :class="{
                                'invalid-feedback': !$v.formPro.code.isUnique,
                              }"
                            >
                                El Codigo {{formPro.code}} ya existen en nuestros registros.
                            </div>
                     
                      <barcode :value="formPro.code" :options="{ format: 'EAN13' }">
                          generando código de barras
                      </barcode>
                        
                    </b-form-group>
                    </b-col>
                     <b-col md="2">
                      <template>
                          <b-button
                          class="mb-2"
                          block
                          variant="success default"
                          @click="crear('code')"
                          >
                          Generar código <i class="bx bxs-add-to-queue check-nav-icon" />
                          </b-button>
                      </template>
                    </b-col>
                  </b-row>
                 
                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="example-textarea">Categoría:</label>
                    </b-col>
                    <b-col md="10">
                     <v-select v-model.trim="$v.formPro.categoria.$model" :state="!$v.formPro.categoria.$error"  :options="arrayCategorias" label="nombre_categoria"
                      >
                      <template #list-footer >
                        <div style="opacity: 0.8">
                            
                               <li style="text-align: center"> <div class="d-grid gap-4">
                                    <b-button
                                      class="mb-0"
                                      block variant="primary" size="sm"
                                      @click="onActionClicked('new-pre')"
                                      v-b-modal.modalSaveCategoria
                                      >Nueva Categoría</b-button
                                    >
                                    </div></li>
                        </div>
                      </template>
                      </v-select>
                      <div
                          :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.categoria.$error && !$v.formPro.categoria.required,
                          }"
                        >
                        Debe seleccionar un categoría
                  </div>
                    </b-col>
                  </b-row>
                
                  <b-row class="mb-4" >
                    <b-col md="2">
                      <label for="example-textarea">No. Parte (serie)</label>
                    </b-col>
                    <b-col md="10">
                     <b-form-input 
                              id="nombre"
                              v-model="formPro.no_parte"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese descripción"
                      ></b-form-input>
                     
                    
                    </b-col>
                  </b-row>
                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="example-textarea">Marca:</label>
                    </b-col>
                    <b-col md="10">
                     <v-select v-model.trim="$v.formPro.marca.$model" :state="!$v.formPro.marca.$error"  :options="arrayMarcas" label="nombre_marca"
                      ><template #list-footer >
                        <div style="opacity: 0.8">
                            
                               <li style="text-align: center"> <div class="d-grid gap-4">
                                    <b-button
                                      class="mb-0"
                                      block variant="primary" size="sm"
                                      @click="onActionClicked('modalSaveMar')"
                                      v-b-modal.modalSaveMar
                                      >Nuevo Marca</b-button
                                    >
                                    </div></li>
                        </div>
                      </template>
                      </v-select>
                        <div
                          :class="{
                              'invalid-feedback': true,
                              'd-block':
                                $v.formPro.marca.$error && !$v.formPro.marca.required,
                          }"
                        >
                        Debe seleccionar un marcas
                  </div>
                    </b-col>
                  </b-row>
                  
                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="billing-phone">Precio Compra</label>
                    </b-col>
                    <b-col md="10">
                      <masked-input
                              v-model="$v.formPro.precio_compra.$model"
                              :state="!$v.formPro.precio_compra.$error"
                              :mask="mask_quetzal"
                              class="form-control "
                              :guide="false"
                              :keep-char-positions="true"
                              :show-mask="true"
                              type="text"
                              placeholder="Ingrese un precio"
                              :class="{
                                'is-invalid': $v.formPro.precio_compra.$error,
                              }"
                            
                            />
                            <div
                              v-if="  $v.formPro.precio_compra.$error &&!$v.formPro.precio_compra.required
                              "
                              class="invalid-feedback"
                            >
                              El Precio compra es obligatorio.
                            </div>
                    </b-col>
                  </b-row>
                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="billing-phone">Precio Venta</label>
                    </b-col>
                    <b-col md="10">
                      <masked-input
                              v-model="$v.formPro.precio_venta.$model"
                              :state="!$v.formPro.precio_venta.$error"
                              :mask="mask_quetzal"
                              class="form-control "
                              :guide="false"
                              :keep-char-positions="true"
                              :show-mask="true"
                              type="text"
                              placeholder="Ingrese un precio"
                              :class="{
                                'is-invalid': $v.formPro.precio_venta.$error,
                              }"
                            
                            />
                            <div
                              v-if="  $v.formPro.precio_venta.$error &&!$v.formPro.precio_venta.required
                              "
                              class="invalid-feedback"
                            >
                              El Precio venta es obligatorio.
                            </div>
                    </b-col>
                  </b-row>
                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="billing-phone">Stock minimo</label>
                    </b-col>
                    <b-col md="10">
                       <input
                              id="name"
                              v-model="$v.formPro.stock_min.$model"
                              type="number"
                              class="form-control"
                              placeholder="Ingrese un numero"
                              :class="{
                                'is-invalid': $v.formPro.stock_min.$error,
                              }"
                              @input="$v.formPro.stock_min.$touch()"
                            />
                            <div
                              v-if="  $v.formPro.stock_min.$error &&!$v.formPro.stock_min.required
                              "
                              class="invalid-feedback"
                            >
                              El Stock es obligatorio.
                            </div>
                    </b-col>
                  </b-row>
                  <b-row class="mb-4" v-if="this.$route.params.opc=='save'">
                    <b-col md="2">
                      <label for="billing-phone">Existencia</label>
                    </b-col>
                    <b-col md="10">
                       <input
                              id="name"
                              v-model="$v.formPro.existencia.$model"
                              type="number"
                              class="form-control"
                              placeholder="Ingrese un numero"
                              :class="{
                                'is-invalid': $v.formPro.existencia.$error,
                              }"
                              @input="$v.formPro.existencia.$touch()"
                            />
                            <div
                              v-if="  $v.formPro.existencia.$error &&!$v.formPro.existencia.required
                              "
                              class="invalid-feedback"
                            >
                              La existencia es obligatoria.
                            </div>
                    </b-col>
                  </b-row>
                  <b-row class="mb-4">
                    
                    <b-col md="2">
                      <label for="billing-address">Imagen producto</label>
                    </b-col>
                    <b-col md="10">
                      <input
                          type="file"
                          v-show="false"
                          accept="image/png, image/jpeg"
                          @change="onSelectedImagen"
                          ref="imageSelector"
                        />

                        <b-button
                          block
                          class="mb-2"
                          size="md"
                          @click="onSelectImagen"
                          variant="primary"
                        >
                          <i :class="'bx bx-image-add'" />&nbsp;&nbsp;Agregar imagen
                        </b-button>
                        <div align="center">
                          <img
                            class="rounded-corners"
                            v-if="localImagen"
                            :src="localImagen"
                            width="50%"
                          />
                        </div>
                    </b-col>
                  </b-row>
                </form>
                <div class="row mt-4">
             
             <!-- end col -->
             <div class="col-sm-12" v-if="this.$route.params.opc=='save'">
               <div class="text-end">
                 <div
                  
                   class="btn btn-success"
                   @click="validaciones('save')"
                 >
                   <i class="mdi mdi-truck-fast me-1"></i> Guardar
                 </div>
               </div>
             </div>
              <!-- end col -->
             <div class="col-sm-12" v-if="this.$route.params.opc=='update'">
               <div class="text-end">
                 <div
                  
                   class="btn btn-success"
                   @click="validaciones('update')"
                 >
                   <i class="mdi mdi-truck-fast me-1"></i> Actualizar
                 </div>
               </div>
             </div>
           </div>
              </div>
              
            </div>
           
          </b-card-text>
        
    </div>
  </Layout>
</template>
